module.exports = __webpack_public_path__ + "static/media/commitment.273e0ffa.png";